export const enum PaymentTypeName {
  insurance = 'insurance',
  cash = 'cash',
}
